export const caracteristicasSectionKeys = [
    "dataReferencia",
    "dataDocumento",
    "versaoDocumento",
    "cetip",
    "isin",
    "numeroSerie",
    "numeroEmissao",
    "tipoAtivo",
    "frequenciaJuros",
    "frequenciaAmortizacao",
    "siteFiduciario",
    "dataEmissao",
    "dataIntegralizacao",
    "dataVencimento",
    "dataCarencia",
    "dataResgateAntecipado",
    "dataVencimentoAntecipado",
    "indexador",
    "remuneracao",
    "puEmissao",
    "spreadEmissao",
    "prazoMedio",
    "prazoEmissao",
    "qtdEmitida",
    "valorSerie",
    "valorTotalEmissao",
    "cotaSubordinacao",
    "cascataPagamento",
    "liquidezDiaria",
    "destinacaoRecursos",
    "tipoOferta",
    "resgateAntecipado",
    "conversibilidade",
    "incentivada",
    "green",
    "lei12431",
    "lei14801",
    "garantiasReais",
    "garantiasFidejussorias",
    "repactuacaoCredito",
    "mitigadorRisco",
    "covenants",
    "prePagamento",
    "agenciaRating",
    "auditoria",
    "registrador",
    "contaRecebedora",
    "depositario",
    "custodiante",
    "cedente",
    "emissor",
    "agenteFiduciario",
    "contaRecebedora",
    "auditoria",
    "agenciaRating",
    "registrador",
    "depositario",
    "custodiante",
    "cedente",
    "emissor",
    "devedor",
    "setorDevedor",
    "subSetorDevedor",
    "resumoDevedor",
    "cobrigacao",
]
